import { Component, OnInit } from '@angular/core';
import { DOCUMENTOS_REGLAMENTO, DocumentoReglamento } from './reglas.data';

@Component({
  selector: 'app-reglas',
  templateUrl: './reglas.component.html',
  styleUrls: ['./reglas.component.css']
})
export class ReglasComponent implements OnInit {

  documentos = DOCUMENTOS_REGLAMENTO;
  documentoActivo: DocumentoReglamento = DOCUMENTOS_REGLAMENTO[0];

  pagina = 1;
  totalPaginas = 0;
  zoom = 1;
  cargandoPdf = true;
  errorPdf = false;

  constructor() { }

  ngOnInit(): void { }

  get zoomPorcentaje(): number {
    return Math.round(this.zoom * 100);
  }

  seleccionarDocumento(doc: DocumentoReglamento): void {
    if (doc === this.documentoActivo) { return; }
    this.documentoActivo = doc;
    this.pagina = 1;
    this.totalPaginas = 0;
    this.zoom = 1;
    this.cargandoPdf = true;
    this.errorPdf = false;
  }

  pdfCargado(pdf: any): void {
    this.totalPaginas = pdf.numPages;
    this.cargandoPdf = false;
  }

  pdfError(error: any): void {
    this.cargandoPdf = false;
    this.errorPdf = true;
  }

  paginaAnterior(): void {
    if (this.pagina > 1) { this.pagina--; }
  }

  paginaSiguiente(): void {
    if (this.pagina < this.totalPaginas) { this.pagina++; }
  }

  acercar(): void {
    if (this.zoom < 2.5) { this.zoom = Math.round((this.zoom + 0.25) * 100) / 100; }
  }

  alejar(): void {
    if (this.zoom > 0.5) { this.zoom = Math.round((this.zoom - 0.25) * 100) / 100; }
  }

  abrirEnPestana(): void {
    window.open(this.documentoActivo.archivo, '_blank');
  }
}
